import { render, staticRenderFns } from "./ti11.vue?vue&type=template&id=841e0b4a&scoped=true&"
import script from "./ti11.vue?vue&type=script&lang=js&"
export * from "./ti11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841e0b4a",
  null
  
)

export default component.exports